const STACK_OVERFLOW_MESSAGE = /Maximum call stack size exceeded|too much recursion/;

/** Our code ships as Vite chunks under /assets/; anything else on a stack is the browser, a library CDN or an injected script. */
function isOwnFrame(frame) {
  return /\/assets\/[^/]+\.js/.test(frame?.filename ?? '');
}

/** The same call site of ours on the stack three or more times: a cycle in our code. */
function ownFramesRecurse(frames) {
  const counts = new Map();

  return frames.filter(isOwnFrame).some((frame) => {
    const key = `${frame.filename}:${frame.lineno}:${frame.colno}`;
    counts.set(key, (counts.get(key) ?? 0) + 1);

    return counts.get(key) >= 3;
  });
}

/**
 * Sentry `beforeSend`. Drops a stack overflow ("Maximum call stack size exceeded", Firefox's
 * "too much recursion") unless our own frames repeat. The browser can run out of stack inside a
 * date parse or an injected script with nothing recursive of ours on it: Firefox 159 does so in
 * moment/dayjs parsing (SHOP-WEB-5D / -6Q), and Chrome for iOS's own content scripts do so with no
 * frame of ours at all (DASHBOARD-WEB-1A, OMS-WEB-A). A real infinite recursion repeats our own
 * call sites (SHOP-WEB-5B), so that one still reports.
 */
export function beforeSendError(event) {
  const isStackOverflowNoise = event?.exception?.values?.some(
    (value) => STACK_OVERFLOW_MESSAGE.test(value.value ?? '') && !ownFramesRecurse(value.stacktrace?.frames ?? []),
  );

  return isStackOverflowNoise ? null : event;
}
